module.exports = __webpack_public_path__ + "img/markerBlue.05c0aa70.svg";